import { render, staticRenderFns } from "./exhibition-order.vue?vue&type=template&id=64ca2597&scoped=true&"
import script from "./exhibition-order.vue?vue&type=script&lang=js&"
export * from "./exhibition-order.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ca2597",
  null
  
)

export default component.exports